'use client';

import * as React from 'react';
import { PRICING_LINK } from '../shared';
import { useSetWindowLocation } from '../../utils/useSetWindowLocation';
import styles from './TopArtistSection.module.css';

export const TopArtistSection = ({
  name,
  code,
  banner,
  link = PRICING_LINK,
}: {
  name: string;
  code: string;
  banner?: string | undefined | null;
  link?: string;
}) => {
  const fallbackImage = '/web_bg.png';
  const setWindowLocation = useSetWindowLocation();

  const handleClick = () => {
    setWindowLocation(`${link}?utm_campaign=${code}`);
  };

  return (
    <div className={styles.container}>
      {}
      <div
        className={styles.backgroundImageAndGradients}
        style={{ backgroundImage: `url(${banner ?? fallbackImage})` }}
      />

      <div className={`${styles.content} u-grid`} data-appeared="true">
        <div>
          <h1 className={styles.title}>
            {name ? `You’ve been invited by ${name}` : 'You’re invited'}.
          </h1>
          <h2 className={styles.subTitle}>
            Track your glucose in real time, to optimize your diet, exercise,
            and recovery. Skip the waitlist and join today.
          </h2>
          <button className={styles.styledButton} onClick={handleClick}>
            Get Access
          </button>
        </div>
      </div>
    </div>
  );
};
